import { render, staticRenderFns } from "./classeofTeacher.vue?vue&type=template&id=5ab4ad2b&"
import script from "./classeofTeacher.vue?vue&type=script&lang=js&"
export * from "./classeofTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports